export const HEADING_BACKGROUND_COLOR = Styles.color.highlight;
export const HEADING_COLOR = Styles.color.white;

export const SHOULD_CHECK_ITEM_IN_OFFER = true;
